import React from "react";
import { pageStyle } from "../../pages/component/style-variable";
import LoadingComponent from "../../shared/loading/loading.component";

function LoadingSuspensePage() {
  return (
    <div className={`${pageStyle}  flex items-center justify-center`}>
      <LoadingComponent
        size={110}
        spinnerWidth={9}
        message="Loading Page..."
        messageStyle="text-lg font-semibold text-primary-500"
      />
    </div>
  );
}

export default LoadingSuspensePage;
